module.exports = __webpack_public_path__ + "static/media/deleteWalls.34429986.gif";